import { FC, useEffect, useState } from 'react';
import { Form } from 'rsuite';
import _ from 'lodash';
import moment from 'moment';
import { Section } from 'components/Rsuite/Section';
import { RsInput } from 'components/Rsuite/Input';
import { RsButton } from 'components/Rsuite/Button';
import useOutboundKeywordForm, {
  Goal,
} from 'containers/RtbCampaigns/RtbCampaignSinglePage/Hooks/useOutboundKeywordForm';
import useBaseForm from 'containers/RtbCampaigns/RtbCampaignSinglePage/Hooks/useBaseForm';
import { useCampaignStore } from 'store/campaignStore';
import { useOrderStore } from 'store/orderStore';
import { BidMode } from 'core/rtbCampaign/singlePage/keyword';
import { ActionType, SelectPattern } from 'core/rtbCampaign/singlePage/common';
import FutureDateRangePicker from 'components/DateRangePicker/FutureDateRangePicker';
import { BudgetChoice } from 'containers/RtbCampaigns/RtbCampaignSinglePage/Components/Display/BudgetChoice';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { TargetTypeSelection } from './OutboundKeyword/TargetTypeSelection';
import styles from './baseForm.module.scss';
import { useFormik, yupToFormErrors } from 'formik';
import useOutboundKeywordValidation from '../Hooks/useOutboundKeywordValidation';
import {
  DefaultRtbCampaignManager,
  RtbCampaignManager,
} from 'core/rtbCampaign/RtbCampaignManager';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import useOutbound from '../Hooks/useOutbound';
import FacebookLogo from 'assets/outboundKeyword/facebook_logo.svg';
import InstagramLogo from 'assets/outboundKeyword/instagram_logo.svg';
import GoogleLogo from 'assets/outboundKeyword/google_logo.svg';
import momoLogo from 'assets/momo_logo.svg';
import OutboundKeywordBanner from 'assets/outboundKeyword/network_banner.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import OutboundKeywordCreatives from './OutboundKeyword/OutboundKeywordCreatives';
import Skeleton from 'react-loading-skeleton';
import TreeSelect from 'components/TreeSelect/TreeSelect';
import { RestfulCampaignWebService, TreeNode } from 'ws/OutboundMetaWebService';
import { TreeDataManager } from 'core/treeSelect/TreeDataManger';
import { RsDateRangePicker } from 'components/Rsuite/DateRangePicker';
import useRetailerManagement from '../Hooks/useRetailerManagement';
import { DefaultRdpManager, RdpManager } from 'core/rdp/RdpManager';
interface OutboundKeywordFormProps {
  defaultForm: any;
}
const campaignManager: RtbCampaignManager = new DefaultRtbCampaignManager();
const defaultRdpManager: RdpManager = new DefaultRdpManager();

const OutboundKeywordForm: FC<OutboundKeywordFormProps> = ({ defaultForm }) => {
  const [treeData, setTreeData] = useState<TreeNode[]>([]);
  const [load, setLoad] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const history = useHistory();
  const { order } = useOrderStore();
  const restfulService = new RestfulCampaignWebService();
  const treeDataManager = new TreeDataManager(restfulService, setLoad);
  const { filters } = useRetailerManagement({
    defaultRdpManager,
  });
  const { actionType, loading, roasList, handleLoading } = useCampaignStore();
  const preprocessDefaultForm =
    actionType === 'copy'
      ? {
          ...defaultForm,
          basic: {
            ...defaultForm.basic,
            outboundInfo: {
              brandNo: '',
              brandName: '',
              name: '',
              logoUrl: '',
              adContent: '',
              goal: Goal.LINK_CLICKS,
            },
          },
        }
      : defaultForm;
  // init Formik
  const { values, setFieldValue, setErrors, handleSubmit } = useFormik({
    initialValues: { ...defaultForm },
    onSubmit: async (values) => {
      const campaign = {
        ...values,
        products: selectedAutoProducts,
        limitations: values.limitations,
      };
      // return
      validationSchema
        .validate(values, { abortEarly: false })
        .then(async function () {
          handleLoading(true);
          try {
            switch (actionType) {
              case 'edit':
                await campaignManager.updateCampaign(
                  campaign,
                  order.l1Objects[0]?.l1ObjectId,
                );
                toast.success('成功');

                history.push(`/orders/${order?.orderNumber}`);
                break;
              case 'create':
                await campaignManager.createCampaign(
                  campaign,
                  order.l1Objects[0]?.l1ObjectId,
                );
                toast.success('成功');
                history.push(`/orders/${order?.orderNumber}`);
                break;
              case 'copy':
                await campaignManager.createCampaign(
                  campaign,
                  order.l1Objects[0]?.l1ObjectId,
                );
                toast.success('成功');
                history.push(`/orders/${order?.orderNumber}`);
                break;
              default:
                break;
            }
          } catch (error) {
            console.error('Failed to create campaign:', error);
            handleLoading(false);
          }
        })
        .catch(function (err) {
          setErrors(yupToFormErrors(err));
          console.log('errors', yupToFormErrors(err));
        });
    },
  });

  // 提交表單
  const onSubmit = () => {
    handleSubmit();
  };
  const { campaignMinDate, handleCampaignNameChange, handleBack } = useBaseForm(
    {
      values,
      setFieldValue,
    },
  );

  const {
    diffDays,
    selectedAutoProducts,
    handleBudgetChange,
    handleDateRangeChange,
    handleChangeStartDate,
    handleChangeEndDate,
    handleBudgetTypeChange,
    handleRoasStrategyChange,
    handleCustomRoasAndInferGoal,
    handleSegmentChange,
    handleGoalChange,
  } = useOutboundKeywordForm({
    defaultForm,
    values,
    setFieldValue,
    filters,
  });

  const {
    handleSetMetaContent,
    handleChangOutbound,
    suggestKeywords,
    outboundBrandOptions,
  } = useOutbound({
    defaultForm: preprocessDefaultForm,
    values,
    diffDays,
    setFieldValue,
    filters,
  });

  const { validationSchema, errors, handleValidation } =
    useOutboundKeywordValidation({
      defaultForm,
      newForm: values,
      diffDays,
    });

  useEffect(() => {
    const fetchTreeData = async () => {
      setLoad(true);
      try {
        const rootNode = await treeDataManager.getDefaultRootNode();
        setTreeData(rootNode);
      } catch (error) {
        console.error('Failed to fetch tree data:', error);
      } finally {
        setLoad(false);
      }
    };
    fetchTreeData();
  }, []);
  // 初始化時獲取品類樹狀資料
  useEffect(() => {
    const outboundInfo = values?.basic?.outboundInfo;
    if (outboundInfo?.segment?.length > 0) {
      setSelectedCategories(outboundInfo.segment);
    }
  }, [values?.basic?.outboundInfo?.segment]);

  useEffect(() => {
    handleValidation();
  }, [values, roasList, diffDays]);

  return (
    <>
      {loading && <LoadingIndicator />}
      <div className='flex h-[217px] items-center justify-between gap-[80px] bg-[#F4F3FF] px-[112px] py-6'>
        <div className='mr-3 w-[520px]'>
          <span>
            <img src={momoLogo} className='mr-6' />
            <img src={FacebookLogo} className='mr-6' />
            <img src={InstagramLogo} className='mr-6' />
            <img src={GoogleLogo} />
          </span>
          <p className='mt-3 text-sm'>
            將您的廣告投放至
            momo及站外聯播網，解鎖更多優質版位，全面觸及潛力轉換用戶，提升曝光覆蓋率與投放成效。
          </p>
        </div>
        <div>
          <img src={OutboundKeywordBanner} className='relative -bottom-2' />
        </div>
      </div>
      <Section title='廣告活動基本設定' className={'min-h-[350px]'}>
        <Form layout='horizontal' className='w-[1260px]'>
          <Form.Group>
            <Form.ControlLabel>活動名稱</Form.ControlLabel>
            <RsInput
              value={values.basic?.name}
              onChange={handleCampaignNameChange}
              className='!w-80'
              errorMessage={errors?.basic?.name}
            />
          </Form.Group>
          <Form.Group controlId='data-range-radio'>
            <Form.ControlLabel>廣告期間</Form.ControlLabel>
            <div className='flex items-center gap-[10px]'>
              <div className='relative float-left'>
                <RsDateRangePicker
                  startDate={moment(values.basic.startDate).format(
                    'YYYY-MM-DD HH:mm',
                  )}
                  endDate={moment(values.basic.endDate).format(
                    'YYYY-MM-DD HH:mm',
                  )}
                  minDate={moment(campaignMinDate).format('YYYY-MM-DD HH:mm')}
                  maxDate={moment(order.endDate)
                    .endOf('day')
                    .format('YYYY-MM-DD HH:mm')}
                  showTimePicker={true}
                  onStartDateChange={handleChangeStartDate}
                  onEndDateChange={handleChangeEndDate}
                  startDatePickerDisabled={
                    actionType === ActionType.EDIT &&
                    new Date(defaultForm.basic.startDate) <= new Date()
                  }
                />
                <Form.ErrorMessage
                  show={
                    !![errors?.basic?.startDate, errors?.basic?.endDate]
                      .filter(Boolean)
                      .join(' / ')
                  }
                  placement='topEnd'
                >
                  {[errors?.basic?.startDate, errors?.basic?.endDate]
                    .filter(Boolean)
                    .join(' / ')}
                </Form.ErrorMessage>
              </div>
              <Form.HelpText className='mt-1 !text-[#5950B5]'>
                總計 {diffDays} 日
              </Form.HelpText>
            </div>
            <div className='flex items-center gap-1'>
              <Form.HelpText className='mt-[5px] flex items-center gap-1'>
                建議活動至少大於兩周，以達到系統最佳學習效果
                <FontAwesomeIcon
                  icon={faQuestionCircle}
                  className='ml-3 text-base text-[#181D27]'
                />
              </Form.HelpText>
            </div>
          </Form.Group>
          <Form.Group controlId='data-range-radio'>
            <Form.ControlLabel>廣告預算</Form.ControlLabel>
            <BudgetChoice
              budgetType={values.basic.budgetType}
              onBudgetTypeChange={handleBudgetTypeChange}
              budget={values.basic.budget}
              dailyTargetBudget={values.basic.dailyTargetBudget}
              onBudgetChange={handleBudgetChange}
              dailyErrorMessage={errors?.basic?.dailyTargetBudget}
              totalErrorMessage={errors?.basic?.budget}
              className={styles.budgets}
              actionType={actionType}
              disabled={true}
            />
            <Form.HelpText className='ml-28'>
              <InfoOutlineIcon className='mr-[5.5px]' />
              無論採用總預算或日預算模式，實際每日花費可能超過日預算上限設定；活動開跑後，不得修改預算模式，若需修改請重新建立廣告
            </Form.HelpText>
          </Form.Group>
        </Form>
      </Section>

      <Section
        title='素材設定'
        className='items-center overflow-hidden !pr-[160px]'
      >
        <OutboundKeywordCreatives
          outboundBrandOptions={outboundBrandOptions}
          defaultForm={preprocessDefaultForm}
          changeAdContent={handleSetMetaContent}
          webBrandNo={values?.basic?.webBrandNo}
          selectPattern={values?.basic?.selectPattern}
          outboundInfo={values?.basic?.outboundInfo}
          changeOutbound={handleChangOutbound}
          errorMessage={
            errors?.basic?.outboundInfo?.brandNo || errors?.autoProducts
          }
          adContentMessage={errors?.basic?.outboundInfo?.adContent}
        />
      </Section>

      <Section title='目標與受眾'>
        <Form layout='horizontal'>
          <Form.Group>
            <Form.ControlLabel>投放目標</Form.ControlLabel>
            <div className='mb-6 flex flex-col gap-1 pt-[10px]'>
              {/* <Form.HelpText className='ml-[8px] !text-sm'>
                活動建立後，將不可於 自動出價與選字/手動出價與選字 模式間切換
              </Form.HelpText> */}
              <TargetTypeSelection
                selectPattern={values?.basic?.selectPattern}
                roasStrategy={values.basic.roasOption?.roasStrategy}
                roas={values?.basic?.roasOption?.roas}
                onRoasStrategyChange={handleRoasStrategyChange}
                onCustomRoasChange={handleCustomRoasAndInferGoal}
                suggestKeywords={suggestKeywords}
                goal={values?.basic?.outboundInfo?.goal}
                roasError={errors?.basic?.roasOption?.roas}
                handleGoalChange={handleGoalChange}
              />
            </div>
            <Form.ControlLabel>受眾</Form.ControlLabel>
            {loading ? (
              <Skeleton width={640} height={40} />
            ) : (
              <TreeSelect
                treeData={treeData}
                value={selectedCategories}
                onChange={(ids) => {
                  setSelectedCategories(ids);
                  handleSegmentChange(ids);
                }}
                placeholder={load ? '載入中...' : '請選擇'}
                loading={load}
                allowClear
                disabled={load}
                autoCheckChildren={true}
                showSelectAll={false}
                width={552}
              />
            )}
            <span className='ml-[220px] mt-[5px] block text-xs leading-5 text-[#717680]'>
              基於 momo 受眾互動與購買資料，輔以 AI
              智能擴量，找到該品類的潛力購買人群。
            </span>
          </Form.Group>
        </Form>
      </Section>
      <Section title=''>
        <ul className='text-xs leading-5 text-[#717680]'>
          <li>此功能不保證達成投入產出比 (ROAS) 或任何成效指標。</li>
          <li>
            當您使用 momo
            聯播網服務，即表示您同意並授權本公司基於付費廣告目的，使用您於 momo
            Ads 廣告平台設定的品牌帳號名稱與 Logo(商標) 進行 Meta
            粉絲專頁與廣告帳號建立、管理及廣告投遞；若您無設定品牌
            Logo(商標)，系統將統一套用 momo購物網 Logo (商標)。
          </li>
          <li>
            請確保廣告內容符合相關法規並不侵害第三方權益，若有問題，您需自行承擔相關法律責任與賠償
          </li>
        </ul>
        <div className='my-8 ml-8 flex items-center gap-4'>
          <RsButton
            appearance='primary'
            onClick={onSubmit}
            disabled={!_.isEmpty(errors)}
          >
            完成
          </RsButton>
          <RsButton appearance='ghost' onClick={handleBack}>
            取消
          </RsButton>
        </div>
      </Section>
    </>
  );
};

export default OutboundKeywordForm;
